import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { requestFailed } from '~src/app/actions/RequestFailedAction';
import { UrlParamKeys } from '~src/app/UrlParamKeys';
import { Messages } from '~src/codegen/Localize';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { setOrderAction } from '~src/spacesPlatform/actions/SetOrderAction';
import { getOrderClausesFromQueryParam } from '~src/spacesPlatform/components/Explorer/ExplorerUrlBindings';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';
import { getDefaultOrderForPublishedConnectionSubSpace } from '~src/ts/models/sort/SortOptionDefinitions';

import { EnterPublishedConnectionSubspaceReduxAction } from '../actions/EnterPublishedConnectionSubspaceAction';

export function* handleEnterPublishedConnectionSubspace(action: EnterPublishedConnectionSubspaceReduxAction): SagaIterator {
  try {
    const spaceInfo: SpaceInfo = {
      item: action.publishedConnectionDetailInfo,
      spaceType: 'virtualConnection',
      subspaceName: action.subspaceName,
    };
    yield put(enterSpace(spaceInfo));
    if (action.requestContent) {
      const hashQuery: any = WindowLocationService.getHashQueryObject();
      const orderFromQuery = getOrderClausesFromQueryParam(
        hashQuery[UrlParamKeys.Order],
        getDefaultOrderForPublishedConnectionSubSpace(spaceInfo)
      );
      yield put(setOrderAction(orderFromQuery));
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
